var setChatService;
var chatService = "";

document.addEventListener("DOMContentLoaded", function () {
  var zipRegion = 0;
  var chatOpen = false;

  //   sessionStorage.setItem(
  //     "lumosZipResult",
  //     '{"Status":"success","Message":"","Data":[{"Zip":23323,"Region":1,"Description":"New Stack"}]}'
  //   );

  setChatService = function () {
    loadFive9Chat()
      .then(openFive9Chat)
      .catch((e) => {
        console.log("Five9ChatPlugin failed to load");
        console.log(e);
      });
  };
  setChatService();

  function setZip(zip) {
    return new Promise((resolve, reject) => {
      // console.log("setZip " + zip);
      var params = "action=get_region_from_zip&zip=" + zip;
      var url = "/wp-content/themes/lumos-tidewater/api_helper.php?" + params;
      var xhr = new XMLHttpRequest();
      xhr.open("GET", url, true);
      xhr.onreadystatechange = function () {
        if (xhr.readyState == 4) {
          if (xhr.status == 200) {
            var zipResult = xhr.responseText;
            var resObject = zipResult;
            if (zipResult.substring(0, 1) != "{") {
              reject();
            } else {
              resObject = JSON.parse(resObject);
              if (resObject["Status"] == "success") {
                // sessionStorage.setItem(
                //   "lumosZipResult",
                //   JSON.stringify(resObject)
                // );
                Cookies.set(
                  "lumosZipResult",
                  JSON.stringify(resObject),
                  { expires: 5 } // Expires in 5 days
                );
                checkAccountZipInput();
              } else {
                console.log("res objectstatus not good");
                console.log(zipResult);
                document
                  .querySelector("#lumosZipModal .zip-not-available")
                  .classList.add("d-none");
                document
                  .querySelector("#lumosZipModal #zipCode")
                  .classList.add("is-invalid");
                document
                  .querySelector("#validationZipFormat")
                  .classList.add("d-none");
                document
                  .querySelector("#lumosZipModal .zip-no-service")
                  .classList.remove("d-none");
                document
                  .querySelector("#lumosZipModal .modal-dialog")
                  .setAttribute("style", "max-width: 385px!important;");
                document
                  .querySelector("#lumosZipModal .modal-body")
                  .setAttribute("style", "height: auto;");
              }
              resolve();
            }
          } else {
            console.log("setZip fail");
            console.log(xhr.responseText);
            reject();
          }
        }
      };
      xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
      xhr.send();
    });
  }

  function loadSFChat() {
    /*
        Salesforce Chat
        refer to https://developer.salesforce.com/docs/atlas.en-us.244.0.snapins_web_dev.meta/snapins_web_dev/snapins_web_overview.htm
    */
    envConsoleLog("loadSFChat");
    chatService = "sf";
    return new Promise((resolve, reject) => {
      // console.log("loadSFChat");
      var script = document.createElement("script");
      script.type = "text/javascript";
      script.src =
        "https://nslumoscomm111.my.salesforce.com/embeddedservice/5.0/esw.min.js";

      script.onload = function () {
        var initESW = function (gslbBaseURL) {
          embedded_svc.settings.displayHelpButton = true; //Or false
          embedded_svc.settings.language = ""; //For example, enter 'en' or 'en-US'
          //   embedded_svc.settings.defaultMinimizedText = "..."; //(Defaults to Chat with an Expert)
          //   embedded_svc.settings.disabledMinimizedText = "..."; //(Defaults to Agent Offline)
          //embedded_svc.settings.loadingText = '';  //(Defaults to Loading)
          //embedded_svc.settings.storageDomain = 'yourdomain.com';  //(Sets the domain for your deployment so that visitors can navigate subdomains during a chat session)
          // Settings for Chat
          //embedded_svc.settings.directToButtonRouting = function(prechatFormData) { // Dynamically changes the button ID based on what the visitor enters in the pre-chat form. // Returns a valid button ID. //};
          //embedded_svc.settings.prepopulatedPrechatFields = {}; //Sets the auto-population of pre-chat form fields
          //embedded_svc.settings.fallbackRouting = []; //An array of button IDs, user IDs, or userId_buttonId
          //embedded_svc.settings.offlineSupportMinimizedText = '...'; //(Defaults to Contact Us)
          embedded_svc.settings.enabledFeatures = ["LiveAgent"];
          embedded_svc.settings.entryFeature = "LiveAgent";
          embedded_svc.settings.widgetHeight = "451px";
          embedded_svc.settings.widgetWidth = "272px";
          // embedded_svc.settings.smallCompanyLogoImgURL = "/wp-content/themes/lumos-tidewater/assets/images/icons/chat-icon.svg";
          embedded_svc.init(
            "https://nslumoscomm111.my.salesforce.com",
            "https://nslumoscomm111.my.site.com/myaccount",
            gslbBaseURL,
            "00D6t000000R6dc",
            "Chat_Team",
            {
              baseLiveAgentContentURL:
                "https://c.la4-c1cs-ia4.salesforceliveagent.com/content",
              deploymentId: "5726t000000GnwT",
              buttonId: "5736t000000Go6S",
              baseLiveAgentURL:
                "https://d.la4-c1cs-ia4.salesforceliveagent.com/chat",
              eswLiveAgentDevName: "Chat_Team",
              isOfflineSupportEnabled: true,
            }
          );

          envConsoleLog(embedded_svc.settings);
        };
        if (!window.embedded_svc) {
          var s = document.createElement("script");
          s.setAttribute(
            "src",
            "https://nslumoscomm111.my.salesforce.com/embeddedservice/5.0/esw.min.js"
          );
          s.onload = function () {
            initESW(null);
            resolve();
          };
          document.body.appendChild(s);
        } else {
          initESW("https://service.force.com");
          resolve();
        }
      };
      document.body.appendChild(script);

      envConsoleLog("Salesforce Chat loaded");
    });
  }

  function loadFive9Chat() {
    chatService = "f9";
    return new Promise((resolve, reject) => {
      // console.log("loadFive9Chat");
      var script = document.createElement("script");
      script.type = "text/javascript";
      script.src =
        "https://psapps006.scl.five9.com/ps-live-chat/Five9ChatPlugin.js";

      script.onload = function () {
        var profileList = isChatActive();
        var currentURI = window.location.pathname;

        if(profileList == false){
          return;
        }

        if (currentURI.includes("business")) {
          profileList = profileList.filter(
            (profile) => profile !== "Residential Sales"
          );
        } else {
          profileList = profileList.filter(
            (profile) => profile !== "Business Sales"
          );
        }

        var profileObj = [{ label: "", value: "" }];
        profileList.forEach((profile) => {
          profileObj.push({
            label: profile,
            value: profile,
          });
        });

        var profileListJSON = JSON.stringify(profileObj);
        var siteUrl = window.location.protocol + "//" + window.location.host;

        let cssLink =
          "/wp-content/themes/lumos-tidewater/assets/css/five9-chat.css";
        if (window.innerWidth < 460) {
          cssLink =
            "/wp-content/themes/lumos-tidewater/assets/css/five9-chat-mobile.css";
        }

        jQuery(document).ready(function ($) {
          let options = {
            appId: "NorthState",
            region: "USA",
            campaignName: "Live Chat",
            showEndButton: true,
            endButtonText: "End Chat",
            minimizeOnEnd: true,
            titleBackgroundColor: "#400080",
            buttonTextColor: "#fff",
            buttonBackgroundColor: "#B003D3",
            miniSubmitColor: "#400080",
            waitingMessage:
              "You are the {{pos}}{{nth}} in queue with a {{wait}} minute wait. Please hold for the next team member to assist you...",
            endConfirmation: true,
            miniForm: true,
            launcherButton:
              siteUrl +
              "/wp-content/themes/lumos-tidewater/assets/images/icons/chat-icon.svg",
            css: siteUrl + cssLink,
            closeButton:
              siteUrl +
              "/wp-content/themes/lumos-tidewater/assets/images/icons/close-line-icon.svg",
            minimizeButton:
              siteUrl +
              "/wp-content/themes/lumos-tidewater/assets/images/icons/close-line-icon.svg",

            title: "Lumos Live Chat",
            subtitle: "Lumos Live Chat",
            formData: [
              {
                type: "select",
                formType: "both",
                required: true,
                label: "How Can We Help You",
                cav: "Chat.Category",
                pos: "",
                value: "",
                readOnly: false,
                options: JSON.parse(profileListJSON),
              },
              {
                label: "Your Name",
                cav: "contact.name",
                formType: "both",
                type: "text",
                required: true,
              },
              {
                label: "Your Email Address",
                cav: "contact.email",
                formType: "both",
                type: "email",
                required: true,
              },
              {
                type: "select",
                formType: "both",
                required: true,
                label: "Your Location (State)",
                cav: "Chat.Location",
                pos: "",
                options: [
                  {
                    label: "",
                    value: "",
                  },
                  {
                    label: "NC",
                    value: "NC",
                  },
                  {
                    label: "VA",
                    value: "VA",
                  },
                  {
                    label: "SC",
                    value: "SC",
                  },
                  {
                    label: "Other",
                    value: "SC",
                  },
                ],
              },
              {
                label: "Question",
                cav: "Question",
                formType: "both",
                type: "textarea",
                required: true,
              },
              {
                label: "Subject",
                cav: "Subject",
                formType: "email",
                type: "text",
                required: true,
              },
            ],
            surveyMsg: "How was your experience today?",
            surveyUrl: "https://www.lumosfiber.com/",
            timezone: "America/New_York",
            miniSubmitBackgroundColorCompleted: "#ffffff",
          };
          Five9ChatPlugin(options);
        });
        // console.log("Five9ChatPlugin loaded");
        resolve();
      };
      script.onerror = function () {
        console.log("Five9ChatPlugin failed to load");
        reject();
      };
      document.body.appendChild(script);
    });
  }

  function openFive9Chat() {
    // console.log("openFive9Chat");
    $(".full-loader").addClass("hide");
    function attemptToClickButton() {
      var $button = $("#five9OpenChatButton");
      if (chatOpen) {
        if ($button.length) {
          $button.click();
          // console.log("Button clicked");
        } else {
          console.log("Button not yet available, retrying...");
          setTimeout(attemptToClickButton, 500); // Check again in 500 milliseconds
        }
      }
    }
    attemptToClickButton();
  }

  function unloadChatService() {
    // console.log("unloadChatService");
    if (
      chatService == "sf" &&
      (zipRegion != 1 ||
        (localStorage.getItem("lumosMixedAccount") &&
          localStorage.getItem("lumosMixedAccount") == true))
    ) {
      closeSFChat();
    } else if (
      chatService == "f9" &&
      zipRegion != 2 &&
      zipRegion != 3 &&
      localStorage.getItem("lumosMixedAccount") &&
      localStorage.getItem("lumosMixedAccount") != true
    ) {
      closeFive9Chat();
    }
  }

  function openSFChat() {
    $(".full-loader").addClass("hide");
    $("#lumosZipModal").modal("hide");
    if (chatOpen) {
      // console.log("openSFChat");
      function attemptToStartChat() {
        if (embedded_svc && embedded_svc.liveAgentAPI) {
          // console.log(embedded_svc.liveAgentAPI);
          // console.log(embedded_svc);
          embedded_svc.bootstrapEmbeddedService();
        } else {
          console.log("Salesforce chat is not yet initialized");
          setTimeout(attemptToStartChat, 500); // Check again in 500 milliseconds
        }
      }
      attemptToStartChat();

      //   console.log(embedded_svc);
    } else {
      $(".sf-chat-button").click(() => {
        embedded_svc.bootstrapEmbeddedService();
      });
      $(".sf-chat-button").removeClass("d-none");
    }
  }
  function getChatSchedule() {
    if (typeof lumosChatData !== "undefined") {
      // Replace with the logic to set the time zone if needed
      const schedule = [];
      // const chatSchedule = get_field("chat_schedule", "option"); // Replace with JavaScript logic
      const chatSchedule = lumosChatData.chat_schedule;

      if (chatSchedule) {
        chatSchedule.forEach((cs) => {
          schedule.push({
            day: cs.day,
            start: new Date("1970-01-01T" + cs.start + "Z").getTime(),
            end: new Date("1970-01-01T" + cs.end + "Z").getTime(),
            profiles: cs.available_profiles,
          });
        });
      }

      return schedule;
    }
  }
  function isChatActive() {
    const options = {
      timeZone: "America/New_York",
      hour12: false,
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
    };
    const currentTime = new Date().toLocaleTimeString("en-US", options);
    const currentTimestamp = new Date(
      "1970-01-01T" + currentTime + "Z"
    ).getTime();
    const currentDay = new Date().toLocaleDateString("en-US", {
      weekday: "short",
    });

    // if (!getThemeMod("show_chat_button")) {
    //   return "";
    // }

    const chatActive = [];
    const schedule = getChatSchedule();

    if (schedule) {
      schedule.forEach((sched) => {
        if (sched.day === currentDay) {
          const startTimestamp = sched.start;
          const endTimestamp = sched.end;
          if (
            currentTimestamp >= startTimestamp &&
            currentTimestamp <= endTimestamp
          ) {
            chatActive.push(sched.profiles);
          }
        }
      });

      return chatActive;
    }else{
      return false;
    }
  }
  function closeSFChat() {
    // console.log("closeSFChat");
    var sfScript = document.querySelectorAll(
      ".embeddedServiceSidebar, .embeddedServiceHelpButton, .help-button"
    );
    if (sfScript) sfScript.forEach((script) => script.classList.add("d-none"));

    //attempt to open hidden alternative chat service
    try {
      var five9Script = document.querySelectorAll(
        "#five9OpenChatButton, #five9LiveChatWidget"
      );
      if (five9Script)
        five9Script.forEach((script) => script.classList.remove("d-none"));
    } catch (e) {}
  }

  function closeFive9Chat() {
    var five9Script = document.querySelectorAll(
      "#five9OpenChatButton, #five9LiveChatWidget"
    );
    if (five9Script)
      five9Script.forEach((script) => script.classList.add("d-none"));

    //attempt to open hidden alternative chat service
    try {
      var sfScript = document.querySelectorAll(
        ".embeddedServiceSidebar, .embeddedServiceHelpButton, .help-button"
      );
      if (sfScript)
        sfScript.forEach((script) => script.classList.remove("d-none"));
    } catch (e) {}
  }

  //prevent form submission
  var modalZipForm = document.getElementById("modalZipForm");

  // if (modalZipForm) {
  //   modalZipForm.addEventListener("submit", function (e) {
  //     e.preventDefault();
  //     e.stopPropagation();
  //   });
  // }

  // Chat Button Click Handler
  // var zipModalButton = document.querySelector("#lumosZipModal .zip-button");
  // if (zipModalButton) {
  //   zipModalButton.addEventListener("click", function (e) {
  //     e.preventDefault();
  //     e.stopPropagation();
  //     // console.log("Chat Button Clicked");
  //     var zipCode = document.querySelector("#lumosZipModal #zipCode").value;

  //     if (!zipCode.match(/^\d{5}$/)) {
  //       document
  //         .querySelector("#lumosZipModal #zipCode")
  //         .classList.add("is-invalid");
  //       document
  //         .querySelector("#validationZipFormat")
  //         .classList.remove("d-none");
  //       document
  //         .querySelector("#lumosZipModal .zip-no-service")
  //         .classList.add("d-none");
  //       document
  //         .querySelector("#lumosZipModal .zip-not-available")
  //         .classList.add("d-none");
  //       document
  //         .querySelector("#lumosZipModal .modal-dialog")
  //         .setAttribute("style", "max-width: 315px!important;");
  //       document
  //         .querySelector("#lumosZipModal .modal-body")
  //         .setAttribute("style", "height: auto;");
  //       document
  //         .querySelector("#lumosZipModal .modal-text")
  //         .classList.add("d-none");
  //       return false;
  //     }
  //     document
  //       .querySelector("#lumosZipModal #zipCode")
  //       .classList.remove("is-invalid");

  //     $(".full-loader").removeClass("hide");
  //     setZip(zipCode)
  //       .then(() => {
  //         chatOpen = true;
  //         setChatService();
  //       })
  //       .catch((e) => {
  //         console.log(e);
  //         document
  //           .querySelector("#lumosZipModal #zipCode")
  //           .classList.add("is-invalid");
  //         document
  //           .querySelector("#validationZipFormat")
  //           .classList.add("d-none");
  //         document
  //           .querySelector("#lumosZipModal .zip-no-service")
  //           .classList.add("d-none");
  //         document
  //           .querySelector("#lumosZipModal .zip-not-available")
  //           .classList.remove("d-none");
  //         document
  //           .querySelector("#lumosZipModal .modal-dialog")
  //           .setAttribute("style", "max-width: 385px!important;");
  //         document
  //           .querySelector("#lumosZipModal .modal-body")
  //           .setAttribute("style", "height: auto;");
  //         document
  //           .querySelector("#lumosZipModal .modal-text")
  //           .classList.remove("d-none");
  //         $(".full-loader").addClass("hide");
  //       });

  //     return false;
  //   });
  // }

  // var zipModal = document.getElementById("lumosZipModal");
  // zipModal.addEventListener("show.bs.modal", function () {
  //   console.log("Modal is opening");
  //   document.querySelector(".lumos-chat-button").classList.add("d-none");
  // });
  // zipModal.addEventListener("hide.bs.modal", function () {
  //   document.querySelector(".lumos-chat-button").classList.remove("d-none");
  // });
});
